import React, { useState } from 'react';
import { View, Text, ImageBackground, SafeAreaView, Image, Linking } from 'react-native';
import { Modal, Button } from 'LocalGluons';
import { SIMPLE_NOTIFICATION_PORTRAIT_BACKGROUND, SIMPLE_NOTIFICATION_LANDSCAPE_BACKGROUND } from 'Options';
import { Device } from 'DeviceUtils';
import { withStore } from 'Store';
import defaultStyles from './styles';

interface WizardProps {
    data: any,
    mCoreConfig: any,
    close?: () => void;
}

const Wizard = ({ data, close
}: WizardProps): React.ReactElement => {
    const [page, setPage] = useState(0);
    const slides = Device.isTabletOrWeb ? data.lanscapeSlides : data.portraitSlides;
    return (
        <ImageBackground
            source={Device.isPhone ?
                SIMPLE_NOTIFICATION_PORTRAIT_BACKGROUND :
                SIMPLE_NOTIFICATION_LANDSCAPE_BACKGROUND}
            style={defaultStyles.container} >
            <SafeAreaView style={defaultStyles.container}>
                <View style={defaultStyles.imageContainer}>
                    <Image
                        source={{ uri: slides[page].image }}
                        style={{ flex: 1, height: undefined, width: undefined }}
                        resizeMode="contain"
                    />
                </View>
                <View style={defaultStyles.buttonContainer}>
                    {
                        slides[page].buttonsInOrder.map((button, index) => {
                            const prevPage = page - 1 || 0;
                            const nexPage = page + 1 >= slides.length ?
                                slides.length - 1 : page + 1;
                            let action;
                            if (button.type === 'PREVIOUS') {
                                action = () => { setPage(prevPage); };
                            }
                            if (button.type === 'START_OVER') {
                                action = () => { setPage(0); };
                            }
                            if (button.type === 'NEXT' || button.type === 'BEGIN') {
                                action = () => { setPage(nexPage); };
                            }
                            if (button.type === 'ACTION') {
                                action = () => {
                                    Linking.openURL(button.externalUrl);
                                    if (typeof close === 'function') {
                                        close();
                                    }
                                };

                            }

                            const mobileThreeButtonsFormat =
                                Device.isPhone && slides[page].buttonsInOrder.length === 3
                                && (index === 1 || index === 0);

                            return <Button
                                key={`wizard_button${Date.now().toString(36) + Math.random().toString(36)}`}
                                style={{
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    // @ts-ignore
                                    button: [
                                        defaultStyles.button,
                                        mobileThreeButtonsFormat ? { width: '47%' } : null
                                    ]

                                }}
                                isSecondary={button.type === 'PREVIOUS' || button.type === 'ACTION'}
                                title={button.name}
                                onPress={action}
                            />;
                        })
                    }
                </View>
            </SafeAreaView>
        </ImageBackground>
    );
};

export default withStore(Wizard);
